@use "variables" as *;

.textField {
  width: 100%;
  position: relative;
}
::placeholder {
  font-weight: bold;
  font-size: $fontSize-m;
}

.input {
  font-weight: bold !important;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.1);
  transition: 0.3s all;
  font-size: $fontSize-m !important;
}
.input:hover {
  background-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
}

.maskedStyle {
  height: 34px;
  font-size: $fontSize-m;
  padding-left: $spacing-m;
  border-width: thin;
  border-color: gray;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.1);
  transition: 0.3s all;
}
.maskedStyle:hover {
  background-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
}
